import { render, staticRenderFns } from "./StatsCampaignsProfitBox.vue?vue&type=template&id=ade320e0&scoped=true&"
import script from "./StatsCampaignsProfitBox.vue?vue&type=script&lang=js&"
export * from "./StatsCampaignsProfitBox.vue?vue&type=script&lang=js&"
import style0 from "./StatsCampaignsProfitBox.vue?vue&type=style&index=0&id=ade320e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ade320e0",
  null
  
)

export default component.exports